import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Step1State {
  basicInfo: IBasicInfo | null;
  quotation: IQuotation | null;
  productinfo: IProductInfo | null;
  transactionId: string;
}

interface IProductInfo {
  productName: string;
  coverageRate: number;
}

interface IBasicInfo {
  paymentOption?: "MP" | "AP";
  forwhom?: "myself" | "child";
  dob?: string;
  promoCode?: string;
  displayBeforeDate?: string;
  beforeDate?: string;
  displayAfterDate?: string;
  afterDate?: string;
  displayMySelfFromDate?: string;
  mySelfFromDate?: number;
  displayMySelfToDate?: string;
  mySelfToDate?: number;
  displayMyChildFromDate?: string;
  myChildFromDate?: number;
  displayMyChildToDate?: string;
  myChildToDate?: number;
  autoApplyPromo?: string;
  discountEligible?: boolean;
  discountValueLabel?: string;
  discountTypeLabel?: "dollar" | "percent"
}

interface IQuotation {
  totalPremium: number;
  premiumDiscount: number | null;
  age: number;
  planName: string;
  promoCodeBE: string;
  annualizePremium: number;
  firstYrAnnualizedPremium: number;
  discountEligible: boolean;
}

const initialState: Step1State = {
  basicInfo: null,
  quotation: null,
  productinfo: {
    productName: "Cancer Cover Plus II",
    coverageRate: 1.5,
  },
  transactionId: "",
};

const step1Slice = createSlice({
  name: "CancerCover-Step1",
  initialState,
  reducers: {
    updateBasicInfo: (state, action: PayloadAction<Partial<IBasicInfo>>) => {
      state.basicInfo = { ...state.basicInfo, ...action.payload };
    },
    updateQuotation: (
      state,
      action: PayloadAction<Partial<IQuotation> | null>
    ) => {
      state.quotation = { ...state.quotation, ...action.payload } as IQuotation;
    },
    updateProductInfo: (state, action: PayloadAction<IProductInfo>) => {
      state.productinfo = action.payload;
    },
    updateTransactionId: (state, action: PayloadAction<string>) => {
      state.transactionId = action.payload;
    },
    updateToIntialState1: (state, action: PayloadAction<any>) => ({
      ...initialState,
    }),
  },
  extraReducers: {},
});

export const {
  updateBasicInfo,
  updateToIntialState1,
  updateTransactionId,
  updateQuotation,
} = step1Slice.actions;

export default step1Slice.reducer;
